import { useEffect, useState } from "react";
import { BrandLogo } from "@/components/landing/BrandLogo";

const links = [
  { href: "#approach", label: "Approach" },
  { href: "#services", label: "Services" },
  { href: "#about", label: "About Jerry" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-b border-border/60 py-2" : "py-4"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
        <a href="#top" className="flex items-center gap-3" aria-label="Jerry's Therapy home">
          <BrandLogo size="header" />
          <div className="leading-tight">
            <div className="font-display text-lg font-semibold text-ink">Jerry's Therapy</div>
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
              Licensed Counseling · MN
            </div>
          </div>
        </a>
        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-foreground/75 transition-colors hover:text-foreground"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          className="inline-flex min-h-12 items-center gap-2 rounded-full bg-primary px-5 py-3 text-sm font-medium text-primary-foreground shadow-[var(--shadow-soft)] transition-transform hover:-translate-y-0.5"
        >
          Book a call
          <span aria-hidden>→</span>
        </a>
      </div>
    </header>
  );
}
